import React, { useState } from 'react';
import { FaUserSlash, FaExclamationCircle } from 'react-icons/fa';
import { IoCloseOutline } from 'react-icons/io5';
import './SuspendModal.css';

const SuspendModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Account Suspension', 
  memberName = '',
  message = 'Please specify why this account is being suspended.', 
  confirmText = 'Suspend Account'
}) => {
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason);
      setReason('');
      onClose();
    }
  };

  return (
    <div className="suspend-modal-overlay" onClick={onClose}>
      <div className="suspend-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="suspend-modal-accent-bar"></div>
        
        <div className="suspend-modal-content">
          <button className="suspend-modal-close" onClick={onClose}>
            <IoCloseOutline />
          </button>
          <div className="suspend-modal-header">
            <div className="suspend-modal-icon">
              <FaUserSlash />
            </div>
            <div>
              <h2>{title}</h2>
              {memberName && <p className="member-name">Member: <strong>{memberName}</strong></p>}
            </div>
          </div>
          
          <div className="suspend-modal-body">
            <div className="info-box">
              <FaExclamationCircle />
              <p>{message}</p>
            </div>
            
            <div className="input-group">
              <label>Suspension Reason</label>
              <textarea
                placeholder="Describe the reason for suspension (e.g., policy violation, inactivity)..."
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                autoFocus
              />
              <span className="input-hint">This reason will be visible to the member upon login attempt.</span>
            </div>
          </div>
          
          <div className="suspend-modal-actions">
            <button className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button 
              className={`btn-confirm ${!reason.trim() ? 'disabled' : ''}`} 
              onClick={handleConfirm}
              disabled={!reason.trim()}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuspendModal;
